import { TextBox } from '@apply/components';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface Item2DescriptionProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Item2Description: React.FC<Item2DescriptionProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [item2, set_item2] = useBudgetFixFlipField<string>(
        propertyGuid,
        (b) => (b.values?.['Expand Primary Structure']?.['Item #2']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Expand Primary Structure': { ...b.values?.['Expand Primary Structure'], 'Item #2': [v, b.values?.['Expand Primary Structure']?.['Item #2']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={item2}
                />
            ) : (
                <TextBox
                    value={item2}
                    onChange={(value) => set_item2(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
